import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { assignInlineVars, mapResponsivePropToCSSVars } from "@faire/retailer-visitor-shared/lib/tailwindUtils";
import classNames from "classnames";
import React from "react";
var colSpanMobileVar = {
    variable: "--f-grid-col",
    className: "col-[--f-grid-col]"
};
var colSpanTabletVar = {
    variable: "--f-grid-col-md",
    className: "md:col-[--f-grid-col-md]"
};
var colSpanDesktopVar = {
    variable: "--f-grid-col-lg",
    className: "lg:col-[--f-grid-col-lg]"
};
var colSpanXLargeVar = {
    variable: "--f-grid-col-xl",
    className: "xl:col-[--f-grid-col-xl]"
};
var orderMobileVar = {
    variable: "--f-order",
    className: "order-[--f-order]"
};
var orderTabletVar = {
    variable: "--f-order-md",
    className: "md:order-[--f-order-md]"
};
var orderDesktopVar = {
    variable: "--f-order-lg",
    className: "lg:order-[--f-order-lg]"
};
var orderXLargeVar = {
    variable: "--f-order-xl",
    className: "xl:order-[--f-order-xl]"
};
export var SDUIFlowLayoutItem = function(param) {
    var itemColSpans = param.itemColSpans, _param_item = param.item, item = _param_item.item, itemKey = _param_item.itemKey, itemOrder = param.itemOrder;
    var _itemColSpans_mobile_and_above;
    var colSpansClientProperty = convertServerResponsivePropertyToClientResponsiveProperty((_itemColSpans_mobile_and_above = itemColSpans.mobile_and_above) !== null && _itemColSpans_mobile_and_above !== void 0 ? _itemColSpans_mobile_and_above : 0, function(value) {
        return "span ".concat(value);
    }, itemColSpans);
    var _mapResponsivePropToCSSVars = mapResponsivePropToCSSVars(colSpansClientProperty, {
        mobileAndAbove: colSpanMobileVar,
        tabletAndAbove: colSpanTabletVar,
        desktopAndAbove: colSpanDesktopVar,
        xLargeAndAbove: colSpanXLargeVar
    }), colSpanVars = _mapResponsivePropToCSSVars.vars, colSpanClasses = _mapResponsivePropToCSSVars.classes;
    var orderVars = undefined;
    var orderClasses = undefined;
    if (itemOrder) {
        var _itemOrder_mobile_and_above;
        var orderProperty = convertServerResponsivePropertyToClientResponsiveProperty((_itemOrder_mobile_and_above = itemOrder.mobile_and_above) !== null && _itemOrder_mobile_and_above !== void 0 ? _itemOrder_mobile_and_above : 0, function(value) {
            return "".concat(value);
        }, itemOrder);
        var _mapResponsivePropToCSSVars1 = mapResponsivePropToCSSVars(orderProperty, {
            mobileAndAbove: orderMobileVar,
            tabletAndAbove: orderTabletVar,
            desktopAndAbove: orderDesktopVar,
            xLargeAndAbove: orderXLargeVar
        }), vars = _mapResponsivePropToCSSVars1.vars, classes = _mapResponsivePropToCSSVars1.classes;
        orderVars = vars;
        orderClasses = classes;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("h-full", colSpanClasses, itemColSpans.mobile_and_above ? "inline-block" : "hidden", itemColSpans.tablet_and_above ? "md:inline-block" : "md:hidden", itemColSpans.desktop_and_above ? "lg:inline-block" : "lg:hidden", itemColSpans.x_large_and_above ? "xl:inline-block" : "xl:hidden", orderClasses),
        style: assignInlineVars(_object_spread({}, colSpanVars, orderVars)),
        children: item
    }, itemKey);
};
